// extracted by mini-css-extract-plugin
module.exports = {"boxView":"InteractiveMessageBoxView_boxView__3GdD3","quickReplies":"InteractiveMessageBoxView_quickReplies__4bL2I"};